<template lang="pug">
footer#footer
	.wrapper
		.group
			picture.logo
				img(src="@images/logo/logo-unifael-branca.svg")
			ul.redes
				li
					a(href="https://www.instagram.com/unifaeloficial", target="_blank")
						FontAwesomeIcon(:icon="icons.faInstagram")
				li
					a(href="https://www.facebook.com/UniFAEL", target="_blank")
						FontAwesomeIcon(:icon="icons.faFacebookF")
				li
					a(href="https://www.twitter.com/unifael", target="_blank")
						FontAwesomeIcon(:icon="icons.faTwitter")
				li
					a(href="https://wa.me/554135145748?text=Gostaria%20de%20informa%C3%A7%C3%B5es%20sobre%20a%20gradua%C3%A7%C3%A3o%20EAD", target="_blank")
						FontAwesomeIcon(:icon="icons.faWhatsapp")
		.group
			h3 Institucional
			<ul class="list-links-footer">
				<li class="li-link-footer">
					<a id="wt184_wtFooter_wt82_wt70" tabindex="0" target="_blank" rel="noopener nofollow" href="https://fael.edu.br/institucional/sobre">Sobre a instituição</a>
				</li>
				<li class="li-link-footer">
					<a id="wt184_wtFooter_wt82_wt9" tabindex="0" href="https://vestibular.fael.edu.br/blog">Blog</a>
				</li>
					<li class="li-link-footer">
					<a id="wt184_wtFooter_wt82_wt3" tabindex="0" target="_blank" rel="noopener nofollow" href="https://social.sereducacional.com/">Social</a>
				</li>
				<li class="li-link-footer">
					<a id="wt184_wtFooter_wt82_wt8" tabindex="0" href="https://vestibular.fael.edu.br/contato">Contato</a>
				</li>
				<li class="li-link-footer">
					<a id="wt184_wtFooter_wt82_wt67" tabindex="0" rel="noopener nofollow" target="_blank" href="https://www.sereducacional.com/cookieconsent/politica_privacidade.html">Aviso de privacidade</a>
				</li>
				<li class="li-link-footer">
					<a id="wt184_wtFooter_wt82_wt26" tabindex="0" href="https://vestibular.fael.edu.br/regulamento">Regulamento</a>
				</li>
			</ul>
		.group
			h3 Áreas de Estudo
			<ul class="list-links-footer list-ft-links-2">
				<li>
					<a id="wt184_wtFooter_wt82_wtAreas_ctl00_wt48" tabindex="0" href="https://vestibular.fael.edu.br/nossos-cursos/areas-criativas/33">Áreas Criativas</a>
				</li>
				<li>
					<a id="wt184_wtFooter_wt82_wtAreas_ctl02_wt48" tabindex="0" href="https://vestibular.fael.edu.br/nossos-cursos/carreiras-em-educacao/38">Carreiras em Educação</a>
				</li>
				<li>
					<a id="wt184_wtFooter_wt82_wtAreas_ctl04_wt48" tabindex="0" href="https://vestibular.fael.edu.br/nossos-cursos/carreiras-em-financas/37">Carreiras em Finanças</a>
				</li>
				<li>
					<a id="wt184_wtFooter_wt82_wtAreas_ctl06_wt48" tabindex="0" href="https://vestibular.fael.edu.br/nossos-cursos/carreiras-em-saude/36">Carreiras em Saúde</a>
				</li>
				<li>
					<a id="wt184_wtFooter_wt82_wtAreas_ctl08_wt48" tabindex="0" href="https://vestibular.fael.edu.br/nossos-cursos/carreiras-em-tecnologia/34">Carreiras em Tecnologia</a>
				</li>
				<li>
					<a id="wt184_wtFooter_wt82_wtAreas_ctl10_wt48" tabindex="0" href="https://vestibular.fael.edu.br/nossos-cursos/carreiras-emergentes/30">Carreiras Emergentes</a>
				</li>
				<li>
					<a id="wt184_wtFooter_wt82_wtAreas_ctl12_wt48" tabindex="0" href="https://vestibular.fael.edu.br/nossos-cursos/comunicacao/5">Comunicação</a>
				</li>
				<li>
					<a id="wt184_wtFooter_wt82_wt73" tabindex="0" href="https://vestibular.fael.edu.br/nossos-cursos">Ver todas</a>
				</li>
			</ul>
		.group
			h3 Área do Candidato
			<ul class="list-links-footer">
				<li class="li-link-footer">
					<a id="wt184_wtFooter_wt82_wt32" tabindex="0" href="https://graduacao.fael.edu.br/candidato">Login</a>
				</li>
			</ul>
		.group
			//- h3 
			//- 	FontAwesomeIcon(:icon="icons.faLocationDot")
				//- span Endereço
			//- p Av. 7 de Setembro, 2774 - Loja 999 - Shopping Estação - Centro - Curitiba - PR
			h3 
				FontAwesomeIcon(:icon="icons.faPhone")
				span Telefone
			p 0800 642 6002
</template>

<script>
import { faInstagram, faFacebookF, faTwitter, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faPhone, faLocationDot } from '@fortawesome/free-solid-svg-icons'

export default {
	name: `component-footer`,
	data() {
		return {
			icons: {
				faInstagram,
				faFacebookF,
				faTwitter,
				faWhatsapp,
				faPhone,
				faLocationDot
			}
		}
	},
}
</script>

<style lang="stylus" scoped src="./Footer.styl"></style>
